import { render, staticRenderFns } from "./InfoContent.vue?vue&type=template&id=6375681f&scoped=true&"
import script from "./InfoContent.vue?vue&type=script&lang=js&"
export * from "./InfoContent.vue?vue&type=script&lang=js&"
import style0 from "./InfoContent.vue?vue&type=style&index=0&id=6375681f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6375681f",
  null
  
)

export default component.exports